<template>
  <div class="premieres" v-if="premieres">
    <h1>{{ premieres.title }}</h1>

    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      :centered-slides="centeredSlides"
      :space-between="spaceView"
      :navigation="showNavigation"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      :pagination="showNavigation ? { clickable: true } : false"
      :scrollbar="showNavigation ? { draggable: true } : false"
    >
      <swiper-slide v-for="(asset, i) in premieres.assets" v-bind:key="i">
        <poster-component :asset="asset"></poster-component>
      </swiper-slide>
    </swiper>
    <router-link :to="$t('routes.discover')">
      <button class="btn browse-all btn-outline-light">
        {{ $t("landing.premieres.browse_all") }}
      </button>
    </router-link>
  </div>
</template>

<script>
import PosterComponent from "../generic/PosterComponent.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { mapState } from "pinia";
import { UIStore } from "../../stores/uiStore";
export default {
  name: "premieres",
  components: { SwiperSlide, Swiper, PosterComponent },
  props: {
    premieres: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(UIStore, ["getCurrentWidth"]),
    spaceView() {
      if (this.isMobile()) {
        return 20;
      } else {
        return 10;
      }
    },
    centeredSlides(){
      return this.isMobile();
    },
    slidesPerView() {
      return this.$breakpoints("home_premieres", this.getCurrentWidth);
    },
    hasMultiplePages() {
      return (
        this.premieres.assets != undefined &&
        this.premieres.assets.length > this.slidesPerView
      );
    },
    showNavigation() {
      return !this.isMobile() && this.hasMultiplePages;
    },
  },
  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log("slide change");
    };
    
 
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, A11y],
    };
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/colors.scss";
.premieres {
  * {
    --swiper-pagination-bullet-opacity: $red !important;
    --swiper-pagination-color: $red !important;
  }

  *,
  *:hover {
    text-decoration: none;
  }
  .btn{
    font-size: 1em;
  }

  color: #2a344b;
  margin: 8em 2em;
  h1 {
    margin-bottom: 1em;
    text-align: center;
    font-size: 2.5em;
    color: #ffffff;
  }
  .browse-all {
    display: block;
    margin: 2em auto;
    padding-left: 4em;
    padding-right: 4em;
  }

  @media (max-width: 767px) {
    margin: 4em 0;
    h1 {
      font-size: 2em;
    }
  }
  --swiper-pagination-bullet-inactive-color: #ffffff;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-color: $red;
  .swiper-wrapper {
    padding-bottom: 3em;
  }
  .swiper-pagination-bullet-active {
    background-color: $red;
    opacity: 1;
  }

  @media (min-width: 1920px) {
    font-size: 0.9vw;
  }
}
</style>
